const fixtures = [{
        path: "/classroom",
        name: "classroom",
        component: () =>
            import ("@/views/fixtures/classroom.vue"),
        meta: {
            title: "装修课堂"
        }
    }, {
        path: "/classroomDetail",
        name: "classroomDetail",
        component: () =>
            import ("@/views/fixtures/classroomDetail.vue"),
        meta: {
            title: "装修课堂详情"
        }
    },
    {
        path: "/team",
        name: "team",
        component: () =>
            import ("@/views/fixtures/team.vue"),
        meta: {
            title: "设计团队"
        }
    }, {
        path: "/organ",
        name: "organ",
        component: () =>
            import ("@/views/fixtures/organ.vue"),
        meta: {
            title: "合作机构"
        }
    },
    {
        path: "/teamDetail",
        name: "teamDetail",
        component: () =>
            import ("@/views/fixtures/teamDetail.vue"),
        meta: {
            title: "设计人员详情"
        }
    }, {
        path: "/case",
        name: "case",
        component: () =>
            import ("@/views/fixtures/case.vue"),
        meta: {
            title: "装修案例"
        }
    }, {
        path: "/caseDetail",
        name: "caseDetail",
        component: () =>
            import ("@/views/fixtures/caseDetail.vue"),
        meta: {
            title: "装修案例详情"
        }
    }, {
        path: "/VRDetail",
        name: "VRDetail",
        component: () =>
            import ("@/views/fixtures/VRDetail.vue"),
        meta: {
            title: "VR详情"
        }
    }, {
        path: "/VR",
        name: "VR",
        component: () =>
            import ("@/views/fixtures/VR.vue"),
        meta: {
            title: "VR"
        }
    }, {
        path: "/fixtures",
        name: "fixtures",
        component: () =>
            import ("@/views/fixtures/fixtures.vue"),
        meta: {
            title: "我要装修"
        }
    }, {
        path: "/fixtures_home",
        name: "fixtures_home",
        component: () =>
            import ("@/views/fixtures/fixtures_home.vue"),
        meta: {
            title: "我要装修"
        }
    }


];
export default fixtures;